export class InstallationServiceModel {
    private readonly _installationServiceOffered: boolean | undefined;

    /**
     * @constructor InstallationServiceModel
     * @param installationService {boolean} - True if the installation service is offered for the product.
     * @description Creates a new InstallationService instance.
     */
    constructor(public readonly installationService?: boolean) {
        this._installationServiceOffered = installationService;
    }

    /**
     * @method isOffered
     * @description Returns true if the installation service is offered for the product.
     * @returns {boolean}
     */
    public get isOffered(): boolean {
        return this._installationServiceOffered ?? false;
    }
}